$(document).on('click', '.answerSubmit', function () {
  let buttons = $('.answerSubmit').not($(this));
  buttons.removeAttr('data-disable-with');
  buttons.attr('disabled', true);
});
